import AnchorJumps from './anchor-jumps.js';
new AnchorJumps();

import NavBar from './navbar.js';
new NavBar();

import LoginRedirectFragment from './login-redirect-fragment.js';
for ( const link of document.querySelectorAll( '#login-form a.btn-primary' ) ) {
	new LoginRedirectFragment( link );
}

import PageMenu from './page-menu.js';
for ( const menu of document.querySelectorAll( '.page-menu' ) ) {
	new PageMenu( menu );
}

import BackToTopButton from './scroll-to-top-button.js';
new BackToTopButton( 'back-to-top-button' );


window.ResizeSensor = require( 'css-element-queries/src/ResizeSensor' );
import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar.js';


var hasAdminBar = document.body.classList.contains( 'admin-bar' );

if ( document.querySelector( '.left-sidebar__content' ) ) {
	var sidebar = new StickySidebar( '.left-sidebar__content', {
		innerWrapperSelector: '.left-sidebar__content-inner',
		containerSelector: '.left-sidebar__wrap',
		topSpacing: hasAdminBar ? 96 : 63,
		bottomSpacing: 0,
		resizeSensor: false,
		minWidth: 992,
	});
	// StickySidebar normally uses ResizeSensor on innerWrapperSelector and
	// containerSelector. This causes problems. Instead, we use ResizeSensor on
	// innerWrapperSelector and .site-main.
  new ResizeSensor(
		document.querySelector( '.left-sidebar__content-inner' ),
		sidebar.handleEvent
	);
  new ResizeSensor(
		document.querySelector( '.site-main' ),
		sidebar.handleEvent
	);
}

if ( document.querySelector( '.right-sidebar__content' ) ) {
	new StickySidebar( '.right-sidebar__content', {
		innerWrapperSelector: '.right-sidebar__content-inner',
		containerSelector: '.right-sidebar__wrap',
		topSpacing: hasAdminBar ? 96 : 63,
		bottomSpacing: 0,
		resizeSensor: true,
	});
}

import TableOfContents from './table-of-contents.js';
new TableOfContents();

import Store from '../store.js';
const { withSelect, withDispatch } = wp.data;

var applyWithSelect = withSelect( ( select, ownProps ) => {
	const { getSelectedUseCase } = select( 'iportal-core' );
	return {
		selectedUseCase: getSelectedUseCase(),
	};
} );

var applyWithDispatch = withDispatch( ( dispatch, ownProps ) => {
	const { selectUseCase } = dispatch( 'iportal-core' );
  return {
		selectUseCase: selectUseCase
  };
} );


import UseCaseSelector from './use-case-selector.jsx';

var Selector = wp.compose.compose(
	applyWithSelect,
	applyWithDispatch,
)( UseCaseSelector );


for ( const element of document.querySelectorAll( '.use-case-selector') ) {
	wp.element.render(
		<Selector useCases={ JSON.parse( element.dataset.useCases ) } />,
		element
	);
}
